import util from '@/libs/util.js'
import Cookies from 'js-cookie'
// eslint-disable-next-line standard/object-curly-even-spacing
import {
  AccountLogin,
  AccountLogout,
  systemSserAdminLoginAnon,
  systemUserDingQRLoginAnon,
  VerificationCodeLogin
} from '@/api/systemPrivilege/account'
import LocalStorage from "@/libs/util.localStorage.js";

export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param username {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login ({ commit, dispatch }, { vm, loginName, password, serverName }) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        AccountLogin({
          loginName,
          password,
          serverName
        })
          .then(async res => {
            if (res.success) {
              LocalStorage.clear()
              if (
                process.env.NODE_ENV == 'advance' ||
                process.env.NODE_ENV == 'production' ||
                process.env.NODE_ENV == 'testing' ||
                process.env.NODE_ENV == 'devtest' ||
                process.env.NODE_ENV === 't3' ||
                process.env.NODE_ENV === 't2' ||
                process.env.NODE_ENV === 't1'
              ) {
                util.cookies.set('uuid', res.data.authUser.userId, { domain: '52rental.com', path: '/' })
                util.cookies.set('sessionId', res.data.sessionId, { domain: '52rental.com', path: '/' })
                util.cookies.set('token', res.data.token, { domain: '52rental.com', path: '/' })
                util.cookies.set('workflow-wap-token', res.data.token, { domain: '52rental.com', path: '/' })
                // 可直接免登陆永洪BI系统(第三方), 此设置方式不会添加系统前缀
                Cookies.set('YHBISESSIONID', res.data.YHBISESSIONID, { domain: '52rental.com', path: '/' })
              } else {
                util.cookies.set('uuid', res.data.authUser.userId)
                util.cookies.set('token', res.data.token)
                // 可直接免登陆永洪BI系统(第三方), 此设置方式不会添加系统前缀
                Cookies.set('YHBISESSIONID', res.data.YHBISESSIONID, { path: '/' })
              }
              // 用户登录后从持久化数据加载一系列的设置
              await dispatch('load')
              vm.$emit('hasLogin')
            }
            // 结束
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    freeLogin ({ commit, dispatch }, { vm, loginName, verificationCode, serverName }) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        VerificationCodeLogin({
          loginName,
          verificationCode,
          serverName
        })
          .then(async res => {
            if (res.success) {
              LocalStorage.clear()
              if (
                process.env.NODE_ENV == 'advance' ||
                process.env.NODE_ENV == 'production' ||
                process.env.NODE_ENV == 'testing' ||
                process.env.NODE_ENV == 'devtest' ||
                process.env.NODE_ENV === 't3' ||
                process.env.NODE_ENV === 't2' ||
                process.env.NODE_ENV === 't1'
              ) {
                util.cookies.set('uuid', res.data.authUser.userId, { domain: '52rental.com', path: '/' })
                util.cookies.set('sessionId', res.data.sessionId, { domain: '52rental.com', path: '/' })
                util.cookies.set('token', res.data.token, { domain: '52rental.com', path: '/' })
                util.cookies.set('workflow-wap-token', res.data.token, { domain: '52rental.com', path: '/' })
                Cookies.set('YHBISESSIONID', res.data.YHBISESSIONID, { domain: '52rental.com', path: '/' })
              } else {
                util.cookies.set('uuid', res.data.authUser.userId)
                util.cookies.set('token', res.data.token)
                Cookies.set('YHBISESSIONID', res.data.YHBISESSIONID, { path: '/' })
              }
              
              // 用户登录后从持久化数据加载一系列的设置
              await dispatch('load')
              vm.$emit('hasLogin')
            }
            // 结束
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    /**
     * 扫码登录 校验信息 存储token
     */
    scanCodeLogin ({ commit, dispatch }, { vm, temAuthCode }) {
      return new Promise((resolve, reject) => {
        systemUserDingQRLoginAnon({ temAuthCode })
          .then(async res => {
            LocalStorage.clear()
            if (
              process.env.NODE_ENV === 'advance' ||
              process.env.NODE_ENV === 'production' ||
              process.env.NODE_ENV === 'testing' ||
              process.env.NODE_ENV === 'devtest' ||
              process.env.NODE_ENV === 't3' ||
              process.env.NODE_ENV === 't2' ||
              process.env.NODE_ENV === 't1'
            ) {
              util.cookies.set('uuid', res.data.authUser.userId, { domain: '52rental.com', path: '/' })
              util.cookies.set('sessionId', res.data.sessionId, { domain: '52rental.com', path: '/' })
              util.cookies.set('token', res.data.token, { domain: '52rental.com', path: '/' })
              util.cookies.set('workflow-wap-token', res.data.token, { domain: '52rental.com', path: '/' })
              Cookies.set('YHBISESSIONID', res.data.YHBISESSIONID, { domain: '52rental.com', path: '/' })
            } else {
              util.cookies.set('uuid', res.data.authUser.userId)
              util.cookies.set('token', res.data.token)
              Cookies.set('YHBISESSIONID', res.data.YHBISESSIONID, { path: '/' })
            }
            await dispatch('load')
            vm.$emit('hasLogin')
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    /**
     * 强制登录 超级权限
     */
    compelLogin ({  commit, dispatch }, { vm, loginName, password, serverName }) {
      return new Promise((resolve, reject) => {
        systemSserAdminLoginAnon({ loginName, password, serverName })
          .then(async res => {
            LocalStorage.clear()
            if (
              process.env.NODE_ENV === 'advance' ||
              process.env.NODE_ENV === 'production' ||
              process.env.NODE_ENV === 'testing' ||
              process.env.NODE_ENV === 'devtest' ||
              process.env.NODE_ENV === 't3' ||
              process.env.NODE_ENV === 't2' ||
              process.env.NODE_ENV === 't1'
            ) {
              util.cookies.set('uuid', res.data.authUser.userId, { domain: '52rental.com', path: '/' })
              util.cookies.set('sessionId', res.data.sessionId, { domain: '52rental.com', path: '/' })
              util.cookies.set('token', res.data.token, { domain: '52rental.com', path: '/' })
              util.cookies.set('workflow-wap-token', res.data.token, { domain: '52rental.com', path: '/' })
              Cookies.set('YHBISESSIONID', res.data.YHBISESSIONID, { domain: '52rental.com', path: '/' })
            } else {
              util.cookies.set('uuid', res.data.authUser.userId)
              util.cookies.set('token', res.data.token)
              Cookies.set('YHBISESSIONID', res.data.YHBISESSIONID, { path: '/' })
            }
            // await dispatch('load')
            vm.$emit('hasLogin')
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout ({ commit, dispatch }, { vm, confirm = false }) {
      /**
       * @description 注销
       */
      function logout () {
        AccountLogout()
          .then(res => {
            if (res.success) {
              // 删除cookie
              util.cookies.remove('token')
              util.cookies.remove('uuid')
              // 清空 vuex 用户信息
              dispatch('d2admin/user/set', {}, { root: true })
              LocalStorage.clear()
              sessionStorage.clear()
              // 跳转路由
              vm.$router.push({
                path: '/login'
              })
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      }
      // 判断是否需要确认
      if (confirm) {
        commit('d2admin/gray/set', true, { root: true })
        vm.$confirm(
          '注销当前账户吗?  打开的标签页和用户设置将会被保存。',
          '确认操作',
          {
            confirmButtonText: '确定注销',
            cancelButtonText: '放弃',
            type: 'warning'
          }
        )
          .then(() => {
            commit('d2admin/gray/set', false, { root: true })
            logout()
          })
          .catch(() => {
            commit('d2admin/gray/set', false, { root: true })
            vm.$message('放弃注销用户')
          })
      } else {
        logout()
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     */
    load ({ commit, dispatch }) {
      return new Promise(async resolve => {
        // DB -> store 加载用户名
        await dispatch('d2admin/user/load', null, { root: true })
        // DB -> store 加载主题
        await dispatch('d2admin/theme/load', null, { root: true })
        // DB -> store 加载页面过渡效果设置
        await dispatch('d2admin/transition/load', null, { root: true })
        // DB -> store 持久化数据加载上次退出时的多页列表
        await dispatch('d2admin/page/openedLoad', null, { root: true })
        // DB -> store 持久化数据加载侧边栏折叠状态
        await dispatch('d2admin/menu/asideCollapseLoad', null, { root: true })
        // DB -> store 持久化数据加载全局尺寸
        await dispatch('d2admin/size/load', null, { root: true })
        // end
        resolve()
      })
    },
    updateSelfPassword ({ commit, dispatch }, { vm }) {
      vm.$router.push({
        path: '/accountManage/accountInfo',
        query: {
          showAccountInfo: 2
        }
      })
    }
  }
}
